import { clsx } from 'clsx';
import { isNil, upperFirst } from 'lodash-es';

import styles from '../../styles/element.module.scss';

export const borderRadiusSizes = [
  'none',
  'base',
  'xs',
  'sm',
  'md',
  'lg',
  'xl'
] as const;
export type BorderRadiusSizes = (typeof borderRadiusSizes)[number];

export interface BorderRadiusProps {
  borderRadius?: BorderRadiusSizes;
  borderTopLeftRadius?: BorderRadiusSizes;
  borderTopRightRadius?: BorderRadiusSizes;
  borderBottomRightRadius?: BorderRadiusSizes;
  borderBottomLeftRadius?: BorderRadiusSizes;
}

export const borderRadiusClassNames = (
  styles: Record<string, string>,
  propKey: string,
  propValue: BorderRadiusSizes | undefined
): Record<string, boolean> => {
  const classNames: Record<string, boolean> = {};

  if (!isNil(propValue)) {
    classNames[
      styles[`${propKey}${upperFirst(propValue)}`] as keyof typeof classNames
    ] = true;
  }

  return classNames;
};

export const borderRadiusHelpers = {
  defaultProps: {
    borderRadius: undefined
  },
  classnames: (props: BorderRadiusProps): string => {
    return clsx({
      ...borderRadiusClassNames(styles, 'borderRadius', props.borderRadius),
      ...borderRadiusClassNames(
        styles,
        'borderRadiusTopLeft',
        props.borderTopLeftRadius
      ),
      ...borderRadiusClassNames(
        styles,
        'borderRadiusTopRight',
        props.borderTopRightRadius
      ),
      ...borderRadiusClassNames(
        styles,
        'borderRadiusBottomRight',
        props.borderBottomRightRadius
      ),
      ...borderRadiusClassNames(
        styles,
        'borderRadiusBottomLeft',
        props.borderBottomLeftRadius
      )
    });
  },
  base: ({
    borderRadius,
    borderTopLeftRadius,
    borderTopRightRadius,
    borderBottomRightRadius,
    borderBottomLeftRadius,
    ...props
  }: BorderRadiusProps & unknown) => props
};
